import { render, staticRenderFns } from "./DashboardFavorites.vue?vue&type=template&id=3321ac9a"
import script from "./DashboardFavorites.vue?vue&type=script&lang=ts"
export * from "./DashboardFavorites.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3321ac9a')) {
      api.createRecord('3321ac9a', component.options)
    } else {
      api.reload('3321ac9a', component.options)
    }
    module.hot.accept("./DashboardFavorites.vue?vue&type=template&id=3321ac9a", function () {
      api.rerender('3321ac9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/cards/DashboardFavorites.vue"
export default component.exports